import React from "react";
import PropTypes from "prop-types";

import Button from "../../../../component/button/Button";
import RightDetail from "./RightDetail";
import SelectInput from "../../../../component/input/SelectInput";
import TextInput2 from "../../../../component/input/TextInput2";

const TopInput = ({
  workerId,
  faceType,
  loginType,
  getDetail,
  setWorkerId,
  setFaceType,
  captureImage,
  userDetailData,
  setCaptureImage,
  showFaceTypeOptions,
  FaceImageComponents
}) => (
  <>
    <div className="row">
      <div className="col-md-5 col-xl-5 col-lg-5 mb-3">
        <div className="row">
          <div className=" col-md-7 col-xl-7 col-lg-7 mb-3">
            <TextInput2
              data-tip
              type="number"
              value={workerId}
              name="workerId"
              required={true}
              data-for="workerId"
              icon="mdi mdi-account-card-details"
              htmlFor="workerId"
              label="Employee Code"
              placeholder="Employee Code"
              onChange={setWorkerId}
            />
          </div>
          <div className="form-group col-md-5 col-xl-5 col-lg-5 mb-3">
            <Button
              title="Get Details"
              type="button"
              className="btn text-white btn-block btn-dark"
              isBackgroundColor={false}
              icon="mdi mdi-arrow-right-thick mr-2"
              onClick={getDetail}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-7 col-xl-7 col-lg-7 mb-3 ">
            <SelectInput
              required={true}
              value={faceType}
              textWhite={false}
              isLabeled={false}
              label="Select Face Type"
              onChange={setFaceType}
            >
              {showFaceTypeOptions}
            </SelectInput>
          </div>
          <div className="col-md-5 col-xl-5 col-lg-5 mb-3 ">
            <SelectInput
              required={true}
              value={captureImage}
              textWhite={false}
              isLabeled={false}
              label="Select Image Type"
              onChange={setCaptureImage}
            >
              <option value={false}>Select Photo</option>
            </SelectInput>
          </div>
          {captureImage ? (
            <div className="col-md-3 col-xl-3 col-lg-3 mb-3">
              <img
                src={FaceImageComponents[faceType]}
                className="img-thumbnail"
                style={{ height: "150px", width: "150px" }}
              />
            </div>
          ) : null}
        </div>
      </div>
      <div className="col-md-7 col-xl-7 col-lg-7">
        <RightDetail
          userDetails={userDetailData}
          loginType={loginType}
        />
      </div>
    </div>
  </>
);

TopInput.propTypes = {
  getDetail: PropTypes.func.isRequired,
  workerId: PropTypes.string.isRequired,
  faceType: PropTypes.string.isRequired,
  loginType: PropTypes.string.isRequired,
  setWorkerId: PropTypes.func.isRequired,
  setFaceType: PropTypes.func.isRequired,
  captureImage: PropTypes.bool.isRequired,
  setCaptureImage: PropTypes.func.isRequired,
  userDetailData: PropTypes.object.isRequired,
  showFaceTypeOptions: PropTypes.array.isRequired,
  FaceImageComponents: PropTypes.object.isRequired
};

export default TopInput;
